import { REGIONS } from "@/data/site";
import { useLanguage } from "@/context/LanguageContext";

export default function Marquee() {
  const { lang } = useLanguage();
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {REGIONS.map((r) => (
        <span key={`${ariaHidden}-${r.id}`} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-cream/75 md:px-12 md:text-3xl">
            {r.name}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <section className="overflow-hidden border-y hairline bg-coal/70 py-6">
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </section>
  );
}
